const dashboard = {
    page_title: 'داشبورد',
    title: 'داشبورد',
    description: 'مروری کلی بر عملکرد برنامه خود داشته باشید',
    total_users: 'مجموع کاربران',
    total_users_tip: 'مجموع کاربران',
    new_users_today: 'کاربران جدید امروز',
    new_users_today_tip: 'تعداد کاربران جدیدی که امروز در برنامه‌های شما ثبت‌نام کرده‌اند',
    new_users_7_days: 'کاربران جدید ۷ روز گذشته',
    new_users_7_days_tip: 'تعداد کاربران جدیدی که در ۷ روز گذشته در برنامه‌های شما ثبت‌نام کرده‌اند',
    daily_active_users: 'کاربران فعال روزانه',
    daily_active_users_tip: 'تعداد کاربران یکتایی که امروز در برنامه‌های شما توکن تبادل کرده‌اند',
    weekly_active_users: 'کاربران فعال هفتگی',
    weekly_active_users_tip: 'تعداد کاربران یکتایی که در ۷ روز گذشته در برنامه‌های شما توکن تبادل کرده‌اند',
    monthly_active_users: 'کاربران فعال ماهانه',
    monthly_active_users_tip: 'تعداد کاربران یکتایی که در ۳۰ روز گذشته در برنامه‌های شما توکن تبادل کرده‌اند',
};
export default Object.freeze(dashboard);
